import React, { useState } from 'react';
import { Space, Button } from '@gr-monorepo/common/ui';
import {
  Text,
  Plate,
  LabelBlock,
  Content,
  Count,
  Description,
  Row,
  DownloadButton,
  ResultBlock,
} from './MultyStageOlympiadStyled';
import FileSaver from 'file-saver';
import { useMultiStageOlympiadStore } from './useMultiStageOlympiadStore';
import LoaderComponent from 'features/shared/Loader';
import { OlympiadsApi } from 'api';
import { useClickStreamContext } from 'features/shared/ClickStream';
import MultiStageOlympModal from '../Modals/MultiStageOlympModal/MultiStageOlympModal';
import { ReactComponent as SertificateIcon } from './images/sertificate_icon.svg';
import pluralize from 'utils/pluralize';
import { numberWithSpaces } from 'utils/numberWithSpaces';
import { Api } from 'api/cabmun-api-public';
import { Widget } from 'models/widgetMultiStageOlympiad';
import MarkdownPreview from 'features/shared/ui/MarkdownPreview/MarkdownPreview';

const MultiStageOlympiad = ({ isFirstFinished, isSecondStarted, isSecondFinished, widget }: { isFirstFinished: boolean, isSecondStarted: boolean, isSecondFinished: boolean, widget: Widget }) => {
  const requestParams = isSecondFinished ? [widget.firstOlympId, widget.secondOlympId] : [widget.firstOlympId];
  const { pending, dataFirstOlymp, dataSecondOlymp, id } = useMultiStageOlympiadStore(widget, requestParams);
  const { logPageEvent } = useClickStreamContext();
  const [showModal, setShowModal] = useState(false);
  const { orderTitle, olympiadName } = widget

  const handleCopyClick = () => {
    logPageEvent?.({
      eventType: `multi_stage_olympiad_modal_copy_click`,
      eventInfo: `Клик по кнопке Скопировать в модальном окне Проинформировать школы`,
    });
  };

  const handleReportDownload = () => {
    const olimpIdsParams = isSecondFinished ? [widget.firstOlympId, widget.secondOlympId] : [widget.firstOlympId];
    const statusParams: Api.GetResultOlympiadsByGradesXlsxStatusEnum = isSecondFinished
    ? Api.GetResultOlympiadsByGradesXlsxStatusEnum._2
    : Api.GetResultOlympiadsByGradesXlsxStatusEnum._1;

    logPageEvent?.({
      eventType: 'main_page_olympiad_results',
      eventInfo: `Клик по кнопке Скачать отчет по итогам ${!isSecondFinished && '1 тура'}' олимпиады'`,
    });
    OlympiadsApi.getResultOlympiadsByGradesXlsx(olimpIdsParams, statusParams)
      .then((response: any) => {
        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        FileSaver.saveAs(blob, `Отчет по олимпиадам.xlsx`);
      })
      .catch(() => {
      });
  }

  const handleInformClick = () => {
    setShowModal(true);
    logPageEvent({
      eventType: `main_page_olympiad_results`,
      eventInfo: `Клик по кнопке Проинформировать`,
    });
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  if (pending) {
    return (
      <Plate>
        <LoaderComponent color={'#825AF7'} />{' '}
      </Plate>
    );
  }
  return (
    <Plate>
      <LabelBlock>
        <div><SertificateIcon /></div>
        <Text style={{'fontSize': '14px', 'fontWeight': '400', 'lineHeight': '17px'}}>
          {orderTitle}
        </Text>
      </LabelBlock>
      <Content>
        <ResultBlock>
          <Text style={{'fontSize': '24px', 'lineHeight': '29px'}}>
            {isSecondFinished ? `Итоги олимпиады ${olympiadName}` : `Итоги олимпиады \n ${olympiadName}, I тур` }
          </Text>
          <Row>
            <Count>{numberWithSpaces(dataFirstOlymp?.realCountStudent || 0)}</Count>
            <Description>{pluralize(dataFirstOlymp?.realCountStudent ?? 0, 'ученик', 'ученика', 'учеников')} <br/>в&nbsp;муниципалитете</Description>
          </Row>
          <Row>
            <Count>{numberWithSpaces(dataFirstOlymp?.participantsCount || 0)}</Count>
            <Description>{pluralize(dataFirstOlymp?.participantsCount  ?? 0, 'ученик принял', 'ученика приняли', 'учеников приняли')} участие <br/>в&nbsp;I туре</Description>
          </Row>
          <Row style={{alignItems: 'center'}}>
            <Count>{numberWithSpaces(dataFirstOlymp?.transitingPrizeholdersCount || 0)}</Count>
            <div>
              <Description>{pluralize(dataFirstOlymp?.transitingPrizeholdersCount ?? 0, 'ученик', 'ученика', 'учеников')} прошли во II тур</Description>
              {!isSecondFinished &&<DownloadButton onClick={() => handleReportDownload()}>Скачать отчет</DownloadButton>}
            </div>
          </Row>
          {isSecondFinished && (
            <>
              <Row>
                <Count>{numberWithSpaces(dataSecondOlymp?.participantsCount || 0)}</Count>
                <Description>{pluralize(dataSecondOlymp?.participantsCount ?? 0, 'ученик принял', 'ученика приняли', 'учеников приняли')} участие во&nbsp;II туре</Description>
              </Row>
              <Row>
                <Count>{numberWithSpaces(dataSecondOlymp?.prizeholdersCount || 0)}</Count>
                  <Description>{pluralize(dataSecondOlymp?.prizeholdersCount ?? 0, 'ученик стал победителем', 'ученика стали победителями', 'учеников стали победителями')} </Description>
              </Row>
            </>
          )}
        </ResultBlock>
        <div>
          {isSecondStarted || isSecondFinished ? (
            <>
              <Text style={{'color': 'rgba(9, 21, 38, 0.6)'}}>
              {isSecondFinished ? 'II тур олимпиады завершен' : 'Стартовал II тур олимпиады'}              </Text>
              {isSecondStarted && widget.secondTourSubInfo && 
              <div style={{ fontSize: '18px', lineHeight: '24px', marginTop: '16px' }}>
                <MarkdownPreview content={widget.secondTourSubInfo} replaceUtmTerm={true} />
              </div>
              }
              {isSecondFinished && <DownloadButton onClick={() => handleReportDownload()}>Скачать отчет</DownloadButton>}
            
            </>
          ) : (
            <Text style={{'color': '#985EFF'}}>
              II тур пройдет {widget.datesSecondTour}
            </Text>
          )}
          <Space size={16} axis="vertical" />
          {(isFirstFinished && !isSecondFinished && !isSecondStarted) && <Button color={'violet'} style={{ width: '100%' }} onClick={handleInformClick}>
            проинформировать школы
          </Button>}
        </div>
      </Content>
      {showModal && <MultiStageOlympModal onCopyClick={handleCopyClick} title="Проинформировать школы о проведении II тура" onClose={handleCloseModal} cabmunId={id || 0} textMessageCopy={widget.modalMessage} />}
    </Plate>
  );
};
export default MultiStageOlympiad;
